module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Chapter III")])]), _vm._v(" "), _c('p', {
    staticClass: "vh1"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Touchez-i, encore: N’ai fendre choux-ous-ou, salope!”")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“Touch it again, and I’ll split your arse, you bitch!”")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Moi j’a dire—’ous pas prêter un rien. ’Ous ni shallope,")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("’ous ni seine, ’ous croire ’ous ni choeur campêche?”")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“I told you, borrow nothing of mine. You have a canoe,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("and a net. Who you think you are? Logwood Heart?”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“’Ous croire ’ous c’est roi Gros Îlet? Voleur bomme!”")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“You think you’re king of Gros Îlet, you tin-stealer?”")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Then in English: “I go show you who is king! Come!”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Hector came out from the shade. And Achille, the")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("moment he saw him carrying the cutlass, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("un homme")])]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("fou,")]), _vm._v(" a madman eaten with envy, replaced the tin")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("he had borrowed from Hector’s canoe neatly back in the prow")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of Hector’s boat. Then Achille, who had had enough")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("of this madman, wiped and hefted his own blade.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And now the villagers emerged from the green shade")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of the almonds and wax-leaved manchineels, for the face-off")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("that Hector wanted. Achille walked off and waited")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("at the warm shallows’ edge. Hector strode towards him.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The villagers followed, as the surf abated")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("its sound, its fear cowering at the beach’s rim.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then, far out at sea, in a sparkling shower")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("arrows of rain arched from the emerald breakwater")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("of the reef, the shafts travelling with clear power")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("in the sun, and behind them, ranged for the slaughter,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("stood villagers, shouting, with a sound like the shoal,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("and hoisting arms to the light. Hector ran, splashing")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("in shallows mixed with the drizzle, towards Achille,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("his cutlass lifted. The surf, in anger, gnashing")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("its tail like a foaming dogfight. Men can kill")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("their own brothers in rage, but the madman who tore")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Achille’s undershirt from one shoulder also tore")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("at his heart. The rage that he felt against Hector")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("was shame. To go crazy for an old bailing tin")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("crusted with rust! The duel of these fishermen")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("was over a shadow and its name was Helen.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ma Kilman had the oldest bar in the village.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Its gingerbread balcony had mustard gables")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("with green trim round the eaves, the paint wrinkled with age.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In the cabaret downstairs there were wooden tables")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("for the downslap of dominoes. A bead curtain")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("tinkled every time she came through it. A neon")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("sign endorsed Coca-Cola under the "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NO PAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAFÉ ALL WELCOME")]), _vm._v(". The "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NO PAIN")]), _vm._v(" was not her own")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("idea, but her dead husband’s. “Is a prophecy,”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ma Kilman would laugh. A hot street led to the beach")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("past the small shops and the clubs and a pharmacy")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("in whose angling shade, his khaki dog on a leash,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the blind man sat on his crate after the pirogues")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("set out, muttering the dark language of the blind,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("gnarled hands on his stick, his ears as sharp as the dog’s.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sometimes he would sing and the scraps blew on the wind")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("when her beads rubbed their rosary. Old St. Omere.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("He claimed he’d sailed round the world. “Monsieur Seven Seas”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("they christened him, from a cod-liver-oil label")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("with its wriggling swordfish. But his words were not clear.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("They were Greek to her. Or old African babble.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Across wires of hot asphalt the blind singer")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("seemed to be numbering things. Who knows if his eyes")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("saw through the shades, tapping his cane with one finger?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("She helped him draw his veteran’s compensation")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("every first of the month from the small Post Office.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("He never complained about his situation")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("like the rest of them. The corner box, and the heat")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("on his hands would make him shift his box to the shade.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Ma Kilman saw Philoctete hobbling up the street,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("so she rose from her corner window, and she laid")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("out the usual medicine for him, a flask of white")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("acajou, and a jar of yellow Vaseline,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("a small enamel basin of ice. He would wait")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("in the No Pain Café all day. There he would lean")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("down and anoint the mouth of the sore on his shin.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Mais qui ça qui rivait-’ous, Philoctete?”")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Moin blessé.”")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“But what is wrong wif you, Philoctete?”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("                                                                       “I am blest")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("wif this wound, Ma Kilman, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("qui pas ka guérir pièce.")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Which will never heal.”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("                                          “Well, you must take it easy.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Go home and lie down, give the foot a lickle rest.”")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Philoctete, his trouser-legs rolled, stares out to sea")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("from the worn rumshop window. The itch in the sore")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("tingles like the tendrils of the anemone,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("and the puffed blister of Portuguese man-o’-war.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He believed the swelling came from the chained ankles")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of his grandfathers. Or else why was there no cure?")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("That the cross he carried was not only the anchor’s")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("but that of his race, for a village black and poor")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("as the pigs that rooted in its burning garbage,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("then were hooked on the anchors of the abattoir.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Ma Kilman was sewing. She looked up and saw his face")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("squinting from the white of the street. He was waiting")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("to pass out on the table. This went on for days.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The ice turned to warm water near the self-hating")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("gesture of clenching his head tight in both hands. She")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("heard the boys in blue uniforms, going to school,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("screaming at his elbow: “Pheeloh! Pheelosophee!”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("A mummy embalmed in Vaseline and alcohol.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("In the Egyptian silence she muttered softly:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“It have a flower somewhere, a medicine, and ways")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("my grandmother would boil it. I used to watch ants")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("climbing her white flower-pot. But, God, in which place?”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where was this root? What senna, what tepid tisanes,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("could clean the branched river of his corrupted blood,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("whose sap was a wounded cedar’s? What did it mean,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("this name that felt like a fever? Well, one good heft")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of his garden-cutlass would slice the damned name clean")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("from its rotting yam. He said, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Merci.”")]), _vm._v(" Then he left.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba559e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 81
// module chunks = 0